var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Container, Grid } from '@mui/material';
import { camelize } from '../../../utils/camelize';
import { useFormik } from 'formik';
import { useRequest } from '../../../hooks/requestHook';
import { useNotify } from '../../../hooks/notificationHook';
import { producer as api } from '../../../api';
import PageSubmitButton from '../../molecules/PageSubmitButton';
import { FormikTextField } from '../../atoms/TextField';
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 20px 30px;\n"], ["\n  margin: 20px 30px;\n"])));
var REQUIRED_FIELDS = ['okagesama_no_mori_price'];
var OkagesamaNoMoriContent = function (_a) {
    var producer = _a.producer, onUpdate = _a.onUpdate;
    var t = useTranslation().t;
    var notify = useNotify();
    var _b = React.useState(false), loading = _b[0], setLoading = _b[1];
    var updateProducer = useRequest(api.update);
    var onSubmit = React.useCallback(function (values) { return __awaiter(void 0, void 0, void 0, function () {
        var formData, data, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!values.okagesama_no_mori_price)
                        return [2 /*return*/];
                    formData = new FormData();
                    formData.append('producer[okagesama_no_mori_price]', values.okagesama_no_mori_price);
                    data = { id: producer.id, producer: formData };
                    setLoading(true);
                    return [4 /*yield*/, updateProducer(data)];
                case 1:
                    response = _a.sent();
                    setLoading(false);
                    if (!response)
                        return [2 /*return*/];
                    onUpdate(response);
                    notify('success', [t('messages.updateSuccess')]);
                    return [2 /*return*/];
            }
        });
    }); }, [producer, onUpdate, notify, updateProducer, t]);
    var validate = React.useCallback(function (values) {
        var errors = {};
        REQUIRED_FIELDS.forEach(function (field) {
            if (values[field] === null ||
                values[field] === undefined ||
                values[field] === '') {
                errors[field] = t('errors.isRequired', {
                    field: t("params.producer.".concat(camelize(field))),
                });
            }
        });
        return errors;
    }, [t]);
    var initialValues = {
        okagesama_no_mori_price: producer.okagesamaNoMoriPrice,
    };
    var formik = useFormik({
        initialValues: initialValues,
        onSubmit: onSubmit,
        validate: validate,
        validateOnChange: true,
        validateOnMount: true,
        enableReinitialize: true,
    });
    return (React.createElement(Wrapper, null,
        React.createElement(Container, { maxWidth: "md" },
            React.createElement("form", { onSubmit: formik.handleSubmit },
                React.createElement(Grid, { container: true, spacing: 4, style: { marginTop: 5 } },
                    React.createElement(FormikTextField, { variant: "outlined", label: t('params.producer.okagesamaNoMoriPrice'), name: "okagesama_no_mori_price", fullWidth: true, formik: formik, disabled: !producer.editableOkagesamaNoMoriPrice })),
                React.createElement(Grid, { item: true, xs: 2 }),
                React.createElement(Grid, { item: true, xs: 8 },
                    React.createElement(PageSubmitButton, { disabled: !formik.isValid ||
                            loading ||
                            !producer.editableOkagesamaNoMoriPrice }, t('buttons.update'))),
                React.createElement(Grid, { item: true, xs: 2 })))));
};
export default OkagesamaNoMoriContent;
var templateObject_1;
